// extracted by mini-css-extract-plugin
export default {"light-background":"product-guide-video_light-background__grrJd"};